// import { useProductFeature } from '@src/pages/[...slug]/components/product/productFeatureProvider'

import { useLocaleContext } from '@src/components/locale/locale.context'
import { STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'

export const useNewPdpDesignV2Bucket = () => {
  const { locale } = useLocaleContext()
  const isUSLocale = locale === 'en-us'
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.NEW_PDP_DESIGN_V2)
  return isUSLocale ? experimentBucket : STATSIG_EXPERIMENTS_BUCKETS.CONTROL
}
